import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { getAccessToken } from "../../../../common/authorization/AuthorizeService";
import ElectionFileUpload from "../../../../common/electionsInputField/ElectionFileUpload";
import ElectionInputTxt from "../../../../common/electionsInputField/ElectionInput";
import Loader from "../../../../common/loader/Loader";
import { MessageContext } from "../../../../common/message";
import { PUT } from "../../../../utils/fetchUtil";

const CancelElectionFileUploadName = "cancellationFile";

const CustomCancelElectionModal = ({ setCancelElectionModal, active, electionState, dispatch }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const message = useContext(MessageContext);
  const [updateInProgress, setUpdateInProgress] = useState(false);

  useEffect(() => {
    if (updateInProgress && electionState.statusId === 5) {
      PUT(
        `/elections/` + electionState.id,
        electionState,
        (response) => {
          if (response.errorMessage) {
            message.toggle({
              title: t("requests.reviewDocuments.action.save.error"),
              content: response.errorMessage,
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
              },
            });
          } else {
            message.toggle({
              title: t("Napomena"),
              content: t("Izbori su otkazani"),
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
              },
            });
          }
        },
        (error) => {
          message.toggle({
            title: t("requests.reviewDocuments.action.save.error"),
            content: error,
            hideNo: true,
            yesLabel: t("modalMessage.okLabel"),
            onYes: () => {
              message.toggle({});
            },
          });
        }
      );
      handleCloseBtn();
      setUpdateInProgress(false);
      history.goBack();
    }
  }, [electionState.statusId, updateInProgress]);

  // Turn on/off modal
  if (!active) {
    return null;
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let payloadData = {};
    payloadData[name] = value;
    dispatch({ type: "update", payload: payloadData });
  };

  const handleCloseBtn = () => {
    dispatch({ type: "update", payload: { cancellationFile: null } });
    dispatch({ type: "update", payload: { reasonForCancellation: null } });
    setCancelElectionModal(false);
  };

  const handleConfirmBtn = async () => {
    if (electionState.reasonForCancellation && electionState?.cancellationFile?.length > 0) {
      let form = new FormData();
      form.append("Id", electionState.id);
      form.append("File", electionState.cancellationFile[0]);

      let requestOptions = {
        method: "POST",
        headers: {
          "Request-Origin": "pisarnica",
          Authorization: "Bearer " + (await getAccessToken()),
        },
        body: form,
        redirect: "follow",
      };

      async function fileCancellationPOST() {
        const fileUploadResponse = await fetch(
          `${process.env.REACT_APP_GATEWAY_URL}/upload-election-cancellation`,
          requestOptions
        );
        const data = await fileUploadResponse.json();
        return data;
      }

      fileCancellationPOST().then((data) => {
        dispatch({ type: "update", payload: { statusId: 5 } });
        dispatch({ type: "update", payload: { cancellationFilePath: "" } }); //FIXME: ?
        dispatch({ type: "update", payload: { cancellationFileUrl: data.href } });
        setUpdateInProgress(true);
      });
    } else if (electionState.reasonForCancellation) {
      dispatch({ type: "update", payload: { statusId: 5 } });
      setUpdateInProgress(true);
    } else {
      message.toggle({
        title: "Napomena",
        content: "Molimo unesite sve označene podatke.",
        hideNo: true,
        yesLabel: t("modalMessage.okLabel"),
        onYes: () => {
          message.toggle({});
        },
      });
    }
  };

  const handleFile = (uploadedFile) => {
    dispatch({ type: "addCancellationFile", payload: uploadedFile });
  };

  const mainModalContent = (
    <>
      <div className="content">
        <div>
          <h2 className="confirm-modal-mobile-header">Otkazivanje:</h2>
        </div>
        <div className="p-5 has-text-centered">
          <div className="confirm-modal-mobile-p is-size-5">
            <ElectionInputTxt
              name="reasonForCancellation"
              isNumber={false}
              placeholder={"Razlog otkazivanja"}
              isRequired={true}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="p-5 has-text-centered">
          <div className="confirm-modal-mobile-p is-size-5">
            <ElectionFileUpload
              placeholder={"Dodaj dokumentaciju"}
              isRequired={false}
              handleFile={handleFile}
              electionState={electionState}
              dispatch={dispatch}
              name={CancelElectionFileUploadName}
              acceptDocx={true}
            />
          </div>
        </div>
      </div>
      <div className="has-text-centered">
        <button
          className="button is-outlined ml-2 confirm-modal-vote-btn"
          id="closebtn"
          onClick={handleCloseBtn}
        >
          Odustani
        </button>
        <button
          className="button is-success ml-2 confirm-modal-vote-btn"
          id="previous"
          onClick={handleConfirmBtn}
        >
          Otkaži
        </button>
      </div>
    </>
  );

  return (
    // className={isMobile ? "modal is-active p-4" : "modal is-active"}
    <div id="modal" className={"modal is-active"}>
      <div className="modal-background"></div>
      <div className="modal-content">
        <div className="box">
          <article className="media">
            <div className="media-left"></div>
            <div style={{ overflow: "hidden" }} className="media-content">
              {mainModalContent}
              {/* {isLoading ? (
                <>
                  <Loader size={`6x`} className="is-flex-grow-1 is-align-self-center" />
                </>
              ) : isCompleted ? (
                <h2 className="has-text-centered m-0">Izbori su uspješno otkazani</h2>
              ) : (
                mainModalContent
              )} */}
            </div>
          </article>
        </div>
      </div>
    </div>
  );
};

export default CustomCancelElectionModal;
